import { render, staticRenderFns } from "./PartsMine.vue?vue&type=template&id=0c2e12ed&"
import script from "./PartsMine.vue?vue&type=script&lang=ts&"
export * from "./PartsMine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports